import {Component, Input} from '@angular/core';
import {FormGroup, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {AccountManagerModel} from '../../api';

@Component({
    selector: 'app-edit-customer-legacy-details',
    templateUrl: './edit-customer-legacy-details.component.html',
    standalone: false
})
export class EditCustomerLegacyDetailsComponent {
  @Input() mainForm: FormGroup;
  @Input() accountManagers: Array<AccountManagerModel>;

  readonly requiredValidator = Validators.required;
  validationMessages = {};
  customerTypes = [
    {viewValue: this.translate.instant('FANS.EDIT-CUSTOMER-FORM.COMPONENT.CUSTOMER-DETAILS.CUSTOMER-TYPE.FORM.DROPDOWN.BUSINESS-CUSTOMER'), value: 1},
    {viewValue: this.translate.instant('FANS.EDIT-CUSTOMER-FORM.COMPONENT.CUSTOMER-DETAILS.CUSTOMER-TYPE.FORM.DROPDOWN.PRIVATE-CUSTOMER'), value: 2},
  ];

  constructor(private translate: TranslateService) {
  }
}
